import React, { Component } from 'react';

/**
 * 动态加载组件的高阶组件
 * 重写为支持Chrome 52版本的写法
 * - 替换箭头函数为普通函数
 * - 替换展开运算符为Object.assign
 */

// 定义组件状态接口
interface LoadableComponentState {
  component: any;
}

/**
 * 动态加载组件的高阶组件
 * @param importComponent 动态导入的组件函数
 */
function LoadComponent(importComponent: () => Promise<any>) {
  return function (props: any) {
    return React.createElement(
      class extends Component<any, LoadableComponentState> {
        constructor(props: any) {
          super(props);
          this.state = {
            component: null
          };
        }

        componentDidMount() {
          var self = this;
          importComponent().then(function (cmp: any) {
            self.setState({ component: cmp.default }); //.default 是模块有default输出接口
          });
        }

        render() {
          var C = this.state.component;
          // 使用Object.assign代替展开运算符
          return C
            ? React.createElement(C, Object.assign({}, this.props))
            : null;
        }
      },
      props
    );
  };
}

export default LoadComponent;
